import { Translation } from "../hooks/useTranslations";

const fr: Translation = {
  languageCode: "fr",
  projects: {
    addTo: "Ajouter au projet",
    all: "Tous les projets",
    new: "Nouveau projet",
    singular: "Projet",
    plural: "Projets",
    my: "Mes projets",
    createNew: "Créer un nouveau projet",
    infos: "Infos du projet",
    delete: "Supprimer le projet",
    removeShared: "Retirer le projet partagé",
    search: "Rechercher des projets",
    shareWithUser: "Partager le projet avec un utilisateur",
    allowUserToEditSharedConfiguration: "Autoriser l'utilisateur à modifier la configuration partagée",
    allowUserToEditSharedProjectAndConfigurations:
      "Autoriser l'utilisateur à modifier le projet partagé et les configurations qu'il contient",
    editSharings: "Modifier les partages",
    invitation: "Invitation au projet",
    invitations: "Invitations au projet",
    invite: "Inviter au projet",
    sharings: "Partages de projet",
    shared: "Projet partagé",
    sentAt: "Envoyé",
    resendInvite: "Renvoyer l'invitation",
    invitePage: {
      badge: "Invitation d'acces au projet",
      loadingProjectDetails: "Chargement des details du projet...",
      collaborationLead: "vous a invite a collaborer sur ce projet et a consulter son contenu partage.",
      projectName: "Nom du projet",
      inviteNoLongerAvailable:
        "Cette invitation n'est plus disponible car elle a deja ete acceptee, refusee ou annulee.",
      acceptSignedIn: "L'acceptation de cette invitation ouvrira immediatement le projet.",
      acceptSignedOut: "L'acceptation de cette invitation vous demandera de vous connecter avant d'acceder au projet.",
      inviteNotFound: "Cette invitation est introuvable. Elle a peut-etre ete supprimee ou le lien est incorrect.",
    },

    invitationStatus: {
      pending: "En attente",
      active: "Active",
      accepted: "Acceptée",
      rejected: "Refusée",
      cancelled: "Annulée",

      statusChanges: {
        rejected: "Invitation refusée. Votre adresse e-mail a été anonymisée et retirée de ce projet.",
        accept: "Invitation acceptée avec succès",
      },
    },

    questions: {
      delete: "Voulez-vous vraiment supprimer ce projet?",
      unshare: "Voulez-vous vraiment annuler le partage du projet avec cet utilisateur?",
      cancelInvite: "Voulez-vous vraiment annuler cette invitation en attente?",
      removeShared:
        "Voulez-vous vraiment retirer ce projet de vos projets partagés ? Vous perdrez l'accès et cette action est irréversible. Le projet et ses configurations ne seront pas affectés.",
    },

    errors: {
      deleteProjectWithConfigurationsNotPossible:
        "Il n'est pas possible de supprimer un projet s'il contient des configurations.",
      deleteProjectWithDocumentsNotPossible:
        "Il n'est pas possible de supprimer un projet s'il contient des documents.",
      notFound: "Projet non trouvé.",
      sharingNotFound: "Partage non trouvé.",
      sharingAlreadyExists: "Ce projet est deja partage avec cet utilisateur.",
      inviteUpdateNotAllowed: "Vous n'etes pas autorise a accepter ou refuser cette invitation.",
      inviteAlreadyExists: "Une invitation existe deja pour cet utilisateur.",
      inviteAlreadyCancelled: "Cette invitation a deja ete annulee.",
      inviteAlreadyAccepted: "Cette invitation a deja ete acceptee.",
      inviteAlreadyRejected: "Cette invitation a deja ete refusee.",
      documentNotFound: "Document non trouvé.",
      missingDocumentName: "Nom du document manquant.",
      documentAlreadyPresent: "Document déjà présent.",
      missingProjectStatus: "Le statut du projet est manquant.",
    },
  },

  configurations: {
    all: "Toutes les configurations",
    new: "Nouvelle configuration",
    plural: "Configurations",
    create: "Créer une configuration",
    createNew: "Créer une nouvelle configuration",
    delete: "Supprimer la configuration",
    removeShared: "Retirer la configuration partagée",
    duplicate: "Dupliquer la configuration",
    addToProject: "Ajouter au projet",
    unlinkFromProject: "Dissocier du projet",
    my: "Mes configurations",
    search: "Rechercher des configurations",
    reset: "Réinitialiser la configuration",

    questions: {
      delete: "Voulez-vous vraiment supprimer cette configuration?",
      reset: "Voulez-vous vraiment réinitialiser toutes les données de la configuration actuelle ?",
      unlinkFromProject: "Voulez-vous vraiment dissocier cette configuration de son projet ?",
      removeShared:
        "Voulez-vous vraiment retirer cette configuration de vos configurations partagées ? Vous perdrez l'accès et cette action est irréversible. La configuration ne sera pas affectée.",
    },

    invitePage: {
      badge: "Invitation d'acces a la configuration",
      loadingConfigurationDetails: "Chargement des details de la configuration...",
      collaborationLead: "vous a invite a collaborer sur cette configuration et a consulter son contenu partage.",
      configurationName: "Nom de la configuration",
      inviteNoLongerAvailable:
        "Cette invitation n'est plus disponible car elle a deja ete acceptee, refusee ou annulee.",
      acceptSignedIn: "L'acceptation de cette invitation ouvrira immediatement la configuration.",
      acceptSignedOut:
        "L'acceptation de cette invitation vous demandera de vous connecter avant d'acceder a la configuration.",
      inviteNotFound: "Cette invitation est introuvable. Elle a peut-etre ete supprimee ou le lien est incorrect.",
    },

    invitationStatus: {
      statusChanges: {
        rejected: "Invitation refusée. Votre adresse e-mail a été anonymisée et retirée de cette configuration.",
        accept: "Invitation acceptée avec succès",
      },
    },

    errors: {
      notFound: "Configuration non trouvée.",
      missingNormative: "La norme de la configuration est manquante.",
      missingSteelVersion: "La version d'acier de la configuration est manquante.",
      missingUpperSupportInstallationType:
        "Le type d'installation de la support supérieure de la configuration est manquant.",
      missingUpperSupport: "Support supérieure de la configuration est manquante.",
      missingAbsorber: "L'absorbeur de la configuration est manquant.",
      missingSystemType: "Le type de système de la configuration est manquant.",
      missingCable: "Le câble de la configuration est manquant.",
      alreadyLinkedToProject: "Cette configuration est déjà liée à un projet.",
      notLinkedToProject: "Cette configuration n'est pas liée à un projet.",
    },
  },

  documents: {
    add: "Ajouter un document",
    all: "Tous les documents",
    alreadyPresent: "Document déjà présent.",
    plural: "Documents",
    delete: "Supprimer un document",
    search: "Rechercher des documents",

    questions: {
      delete: "Voulez-vous vraiment supprimer ce document?",
      overwrite: "Voulez-vous écraser le document déjà présent?",
    },

    errors: {
      someCouldNotBeSaved: "Certains documents n'ont pas pu être enregistrés",
    },
  },

  systems: {
    all: "Tous les systèmes",
    new: "Nouveau système",
    singular: "Système",
    plural: "Systèmes",
    delete: "Supprimer le système",
    search: "Rechercher des systèmes",
    our: "Nos systèmes",

    questions: {
      delete: "Voulez-vous vraiment supprimer ce système?",
    },

    errors: {
      notFound: "Système non trouvé.",
      inUseByConfiguration: "Le système est encore utilisé par une configuration.",
    },
  },

  entityAccesses: {
    title: "Autorisations utilisateur",
    add: "Ajouter une autorisation utilisateur",
    accessColumn: "Accès",
    questions: {
      remove: "Voulez-vous vraiment supprimer l'accès de cet utilisateur?",
    },
    errors: {
      alreadyExists: "Cet utilisateur a déjà une autorisation pour cet élément.",
    },
  },

  users: {
    add: "Ajouter un utilisateur",
    all: "Tous les utilisateurs",
    iam: {
      label: "IAM",
      missing: "Manquant",
      valid: "Valide",
    },
    invite: "Inviter un utilisateur",
    plural: "Utilisateurs",
    remove: "Supprimer l'utilisateur",
    search: "Rechercher des utilisateurs",
    usersEmail: "E-mail des utilisateurs",
    usersName: "Nom des utilisateurs",

    questions: {},

    errors: {
      notFound: "Utilisateur non trouvé.",
      notFoundInAccounts: "Utilisateur non trouvé dans accounts.",
    },
  },

  items: {
    all: "Tous les articles",
    singular: "Article",
    plural: "Articles",
    createNew: "Créer un nouvel article",
    delete: "Supprimer l'article",
    search: "Rechercher des articles",
    list: "Liste des articles",

    questions: {
      delete: "Voulez-vous vraiment supprimer cet article?",
    },

    errors: {
      notFound: "Article non trouvé.",
      doesNotExist: "L'article avec ce code n'existe pas.",
      missingCode: "Le code de l'article est manquant.",
    },
  },

  absorbers: {
    singular: "Absorbeur",
    plural: "Absorbeurs",
    createNew: "Créer un nouvel absorbeur",
    delete: "Supprimer l'absorbeur",
    edit: "Modifier l'absorbeur",
    search: "Rechercher des absorbeurs",
    removeFromSystem: "Retirer l'absorbeur du système",

    questions: {
      delete: "Voulez-vous vraiment supprimer cet absorbeur?",
      removeFromSystem: "Voulez-vous vraiment retirer cet absorbeur du système?",
    },

    errors: {
      alreadyPresent: "Absorbeur déjà présent.",
      notFound: "Absorbeur non trouvé.",
      noDefined: "Aucun absorbeur défini.",
      inUseByConfiguration: "L'absorbeur est encore utilisé par une configuration.",
    },
  },

  cables: {
    createNew: "Créer un nouveau câble",
    delete: "Supprimer le câble",
    edit: "Modifier le câble",
    search: "Rechercher des câbles",
    singular: "Câble",
    plural: "Câbles",

    questions: {
      delete: "Voulez-vous vraiment supprimer ce câble?",
    },

    errors: {
      alreadyPresent: "Câble déjà présent.",
      notFound: "Câble non trouvé.",
      noDefined: "Aucun câble défini.",
      inUseByConfiguration: "Le câble est encore utilisé par une configuration.",
    },
  },

  handles: {
    addItemAsVertigrip: "Ajouter l'article en tant que poignée Vertigrip",
    delete: "Supprimer la poignée",
    edit: "Modifier la poignée",
    singular: "Poignée",
    plural: "Poignées",
    search: "Rechercher des poignées",
    noHandle: "Aucune poignée",

    questions: {
      delete: "Voulez-vous vraiment supprimer cette poignée?",
    },

    errors: {
      alreadyPresent: "Poignée déjà présente.",
      notFound: "Poignée non trouvée.",
      inUseByConfiguration: "La poignée est encore utilisée par une configuration.",
      inUseByUpperExtension: "La poignée est encore utilisée par une extension supérieure.",
    },
  },

  intermediateElements: {
    createNew: "Créer un nouvel élément intermédiaire",
    delete: "Supprimer l'élément intermédiaire",
    edit: "Modifier l'élément intermédiaire",
    singular: "Élément intermédiaire",
    plural: "Éléments intermédiaires",
    search: "Rechercher des éléments intermédiaires",

    questions: {
      delete: "Voulez-vous vraiment supprimer cet élément intermédiaire?",
    },

    errors: {
      alreadyPresent: "Élément intermédiaire déjà présent.",
      notFound: "Élément intermédiaire non trouvé.",
      inUseByConfiguration: "L'élément intermédiaire est encore utilisé par une configuration.",
    },
  },

  ladderReinforcements: {
    createNew: "Créer un nouveau renfort d'échelle",
    delete: "Supprimer le renfort d'échelle",
    edit: "Modifier le renfort d'échelle",
    singular: "Renfort d'échelle",
    plural: "Renforts d'échelle",
    search: "Rechercher des renforts d'échelle",
    noLadderReinforcement: "Aucun renfort d'échelle",

    questions: {
      delete: "Voulez-vous vraiment supprimer ce renfort d'échelle?",
    },

    errors: {
      alreadyPresent: "Renfort d'échelle déjà présent.",
      notFound: "Renfort d'échelle non trouvé.",
      inUseByConfiguration: "Renfort d'échelle est encore utilisé par une configuration.",
    },
  },

  wallMaterials: {
    createNew: "Créer un nouveau matériau de mur",
    delete: "Supprimer le matériau de mur",
    singular: "Matériau de mur",
    plural: "Matériaux de mur",
    search: "Rechercher des matériaux de mur",
    noWallMaterial: "Aucun matériau de mur",

    questions: {
      delete: "Voulez-vous vraiment supprimer ce matériau de mur?",
    },

    errors: {
      notFound: "Matériau de mur non trouvé.",
      inUseByConfiguration: "Le matériau de mur est encore utilisé par une configuration.",
    },
  },

  wallMaterialFixings: {
    createNew: "Créer un nouveau fixation",
    delete: "Supprimer la fixation",
    singular: "Fixation",
    plural: "Fixations",
    search: "Rechercher des fixations",

    questions: {
      delete: "Voulez-vous vraiment supprimer cette fixation?",
    },

    errors: {
      notFound: "Fixation non trouvée.",
      inUseByConfiguration: "La fixation est encore utilisée par une configuration.",
    },
  },

  wallMaterialFixingItems: {
    errors: {
      alreadyPresent: "Fixation déjà présente.",
    },
  },

  lowerElements: {
    createNew: "Créer un nouvel élément inférieur",
    delete: "Supprimer l'élément inférieur",
    edit: "Modifier l'élément inférieur",
    singular: "Élément inférieur",
    plural: "Éléments inférieurs",
    search: "Rechercher des éléments inférieurs",

    questions: {
      delete: "Voulez-vous vraiment supprimer cet élément inférieur?",
    },

    errors: {
      alreadyPresent: "Élément inférieur déjà présent.",
      notFound: "Élément inférieur non trouvé.",
      inUseByConfiguration: "L'élément inférieur est encore utilisé par une configuration.",
    },
  },

  shuttles: {
    addItemAsVertigrip: "Ajouter l'article en tant que navette Vertigrip",
    addItemAsPatrol: "Ajouter l'article en tant que navette Patrol",
    delete: "Supprimer la navette",
    edit: "Modifier la navette",
    singular: "Navette",
    plural: "Navettes",
    search: "Rechercher des navettes",
    no: "Aucune navette",

    questions: {
      delete: "Voulez-vous vraiment supprimer cette navette?",
    },

    errors: {
      alreadyPresent: "Navette déjà présente.",
      notFound: "Navette non trouvée.",
      inUseByConfiguration: "Navette est encore utilisé par une configuration.",
    },
  },

  installationTypes: {
    plural: "Types d'installation",
    singular: "Type d'installation",
    search: "Rechercher des types d'installation",

    questions: {
      delete: "Voulez-vous vraiment supprimer ce type d'installation?",
    },

    errors: {
      notFound: "Type d'installation non trouvé.",
      inUseByConfiguration: "Le type d'installation est encore utilisé par une configuration.",
      inUseByUpperExtension: "Le type d'installation est encore utilisé par une extension supérieure.",
      inUseByLowerElement: "Le type d'installation est encore utilisé par un élément inférieur.",
      inUseByIntermediateElement: "Le type d'installation est encore utilisé par un élément intermédiaire.",
      inUseByLadderReinforcement: "Le type d'installation est encore utilisé par un renfort d'échelle.",
    },
  },

  steelVersions: {
    createNew: "Créer une nouvelle version d'acier",
    delete: "Supprimer la version d'acier",
    singular: "Version d'acier",
    plural: "Versions d'acier",
    search: "Rechercher des versions d'acier",

    questions: {
      delete: "Voulez-vous vraiment supprimer cette version d'acier?",
    },

    warnings: {
      deleteWarning: "Attention ! Cette action supprimera la version d'acier et toutes les données associées.",
      editWarning: "Attention ! La modification peut affecter les configurations existantes.",
    },

    errors: {
      notFound: "Version d'acier non trouvée.",
      inUseByConfiguration: "La version d'acier est encore utilisée par une configuration.",
      inUseByUpperExtension: "La version d'acier est encore utilisée par une extension supérieure.",
      inUseByLowerElement: "La version d'acier est encore utilisée par un élément inférieur.",
      inUseByIntermediateElement: "La version d'acier est encore utilisée par un élément intermédiaire.",
      inUseByAsorber: "La version d'acier est encore utilisée par un absorbeur.",
      inUseBySupport: "La version en acier est encore utilisée par un support.",
      inUseByCurvesIntermediate: "La version en acier est encore utilisée par un matériau de courbe ou intermédiaire.",
      inUseByTerminal: "La version en acier est encore utilisée par un matériau terminal.",
      inUseByShuttle: "La version en acier est encore utilisée par un matériau de navette.",
      inUseByAnchorMapping: "La version en acier est encore utilisée par un mappage d'ancrage.",
      inUseByConfigurationAnchorPoint:
        "La version en acier est encore utilisée par un point d'ancrage de configuration.",
    },
  },

  upperExtensions: {
    createNew: "Créer une nouvelle extension supérieure",
    delete: "Supprimer l'extension supérieure",
    edit: "Modifier l'extension supérieure",
    singular: "Extension supérieure",
    plural: "Extensions supérieures",
    search: "Rechercher des extensions supérieures",

    questions: {
      delete: "Voulez-vous vraiment supprimer cette extension supérieure?",
    },

    errors: {
      alreadyPresent: "Extension supérieure déjà présente.",
      notFound: "Extension supérieure non trouvée.",
      noDefined: "Aucune extension supérieure définie.",
      inUseByConfiguration: "L'extension supérieure est encore utilisée par une configuration.",
    },
  },

  normatives: {
    createNew: "Créer une nouvelle norme",
    delete: "Supprimer la norme",
    singular: "Norme",
    plural: "Normes",
    search: "Rechercher des normes",
    add: "Ajouter une norme",

    questions: {
      delete: "Voulez-vous vraiment supprimer cette norme?",
    },

    errors: {
      notFound: "Norme non trouvée.",
      noDefined: "Aucune norme définie.",
      inUseByConfiguration: "La norme est encore utilisée par une configuration.",
    },
  },

  systemTypes: {
    singular: "Type de système",
    plural: "Types de système",
    search: "Rechercher des types de système",

    questions: {
      delete: "Voulez-vous vraiment supprimer ce type de système?",
    },

    errors: {
      notFound: "Type de système non trouvé.",
      inUseByConfiguration: "Le système est encore utilisé par une configuration.",
      inUseByShuttle: "Le système est encore utilisé par une navette.",
      inUseByIntermediateElement: "Le système est encore utilisé par un élément intermédiaire.",
    },
  },

  texts: {
    singular: "Texte",
    plural: "Textes",
    search: "Rechercher des textes",

    questions: {
      delete: "Voulez-vous vraiment supprimer ce texte?",
    },

    errors: {
      alreadyPresent: "Le texte est déjà présent.",
      notFound: "Texte non trouvé.",
      missingId: "L'ID du texte est manquant.",
      missingValue: "La valeur du texte est manquante.",
    },
  },

  clients: {
    all: "Tous les clients",
    plural: "Clients",
    createNew: "Créer un nouvel client",
    delete: "Supprimer l'client",
    search: "Rechercher des clients",

    questions: {
      delete: "Voulez-vous vraiment supprimer ce système?",
    },

    errors: {
      notFound: "Client non trouvé.",
      insertNotAllowed: "Vous n'êtes pas autorisé à insérer un nouvel client.",
      readNotAllowed: "Vous n'êtes pas autorisé à lire cet client.",
      updateNotAllowed: "Vous n'êtes pas autorisé à mettre à jour cet client.",
      deleteNotAllowed: "Vous n'êtes pas autorisé à supprimer l'client.",
    },
  },

  roles: {
    plural: "Rôles",
  },

  permissions: {
    plural: "Permissions",
  },

  secrets: {
    plural: "Secrets",

    errors: {
      missingValue: "Valeur d'secret manquant.",
    },
  },

  substructures: {
    createNew: "Créer une nouvelle sous-structure",
    delete: "Supprimer la sous-structure",
    singular: "Sous-structure",
    plural: "Sous-structures",
    single: "Sous-structure",
    search: "Rechercher des sous-structures",
    edit: "Modifier la sous-structure",

    questions: {
      delete: "Voulez-vous vraiment supprimer cette sous-structure ?",
    },
  },

  bases: {
    createNew: "Créer une nouvelle base",
    delete: "Supprimer la base",
    singular: "Base",
    plural: "Bases",
    search: "Rechercher des bases",
    edit: "Modifier la base",
    add: "Ajouter base",

    questions: {
      delete: "Voulez-vous vraiment supprimer cette base ?",
    },

    errors: {
      alreadyPresent: "Base déjà présent",
      notFound: "Base non trouvé",
    },
  },

  ballasts: {
    createNew: "Créer un nouveau lest",
    delete: "Supprimer le lest",
    singular: "Lest",
    plural: "Lests",
    search: "Rechercher des lests",
    edit: "Modifier le lest",
    add: "Ajouter lest",

    questions: {
      delete: "Voulez-vous vraiment supprimer ce lest ?",
    },

    errors: {
      alreadyPresent: "Ballast déjà présent",
      notFound: "Ballast non trouvé",
    },
  },

  ballastTypes: {
    createNew: "Créer un nouveau type de lest",
    delete: "Supprimer le type de lest",
    singular: "Type de lest",
    plural: "Types de lest",
    search: "Rechercher des types de lest",
    edit: "Modifier le type de lest",

    questions: {
      delete: "Voulez-vous vraiment supprimer ce type de lest ?",
    },

    errors: {
      missingName: "Nom du type de lest manquant",
      notFound: "Type de lest non trouvé",
    },
  },

  uprights: {
    createNew: "Créer un nouveau montant",
    delete: "Supprimer le montant",
    singular: "Montant",
    plural: "Montants",
    search: "Rechercher des montants",
    edit: "Modifier le montant",
    add: "Ajouter montant",

    questions: {
      delete: "Voulez-vous vraiment supprimer ce montant ?",
    },

    errors: {
      alreadyPresent: "Montant déjà présent",
      notFound: "Montant non trouvé",
    },
  },

  uprightTypes: {
    createNew: "Créer un nouveau type de montant",
    delete: "Supprimer le type de montant",
    singular: "Type de montant",
    plural: "Types de montant",
    search: "Rechercher des types de montant",
    edit: "Modifier le type de montant",
    add: "Ajouter un type de montant",

    questions: {
      delete: "Voulez-vous vraiment supprimer ce type de montant ?",
    },

    errors: {
      missingName: "Le nom du type de montant est obligatoire",
      notFound: "Type de montant non trouvé",
      inUseByUprights: "Le type de montant est encore utilisé par un ou plusieurs montants",
    },
  },

  guardrailCompositions: {
    createNew: "Créer une nouvelle composition de garde-corps",
    delete: "Supprimer la composition de garde-corps",
    singular: "Composition de garde-corps",
    plural: "Compositions de garde-corps",
    search: "Rechercher des compositions de garde-corps",
    edit: "Modifier la composition de garde-corps",
    add: "Ajouter composition de garde-corps",

    questions: {
      delete: "Voulez-vous vraiment supprimer cette composition de garde-corps ?",
    },

    errors: {
      missingName: "Le nom de la composition de garde-corps est manquant",
      notFound: "Composition de garde-corps introuvable",
    },
  },

  rails: {
    createNew: "Créer un nouveau rail",
    delete: "Supprimer le rail",
    singular: "Rail",
    plural: "Rails",
    search: "Rechercher des rails",
    edit: "Modifier le rail",
    add: "Ajouter rail",

    questions: {
      delete: "Voulez-vous vraiment supprimer ce rail ?",
    },

    errors: {
      alreadyPresent: "Rail déjà présent",
      notFound: "Rail non trouvé",
    },
  },

  toeBoards: {
    createNew: "Créer une nouvelle plinthe",
    delete: "Supprimer la plinthe",
    singular: "Plinthe",
    plural: "Plinthes",
    search: "Rechercher des plinthes",
    edit: "Modifier la plinthe",
    add: "Ajouter plinthe",

    questions: {
      delete: "Voulez-vous vraiment supprimer cette plinthe ?",
    },

    errors: {
      alreadyPresent: "Plinthe déjà présente",
      notFound: "Plinthe non trouvée",
    },
  },

  toeBoardExtras: {
    createNew: "Créer une nouvelle plinthe extra",
    delete: "Supprimer la plinthe extra",
    singular: "Plinthe extra",
    plural: "Plinthes extra",
    search: "Rechercher des plinthes extra",
    edit: "Modifier la plinthe extra",
    add: "Ajouter plinthe extra",

    questions: {
      delete: "Voulez-vous vraiment supprimer cette plinthe extra ?",
    },

    errors: {
      alreadyPresent: "Plinthe extra déjà présente",
      notFound: "Plinthe extra non trouvée",
    },
  },

  uprightCaps: {
    createNew: "Créer un nouveau capuchon de montant",
    delete: "Supprimer le capuchon de montant",
    singular: "Capuchon de montant",
    plural: "Capuchons de montant",
    search: "Rechercher des capuchons de montant",
    edit: "Modifier le capuchon de montant",
    add: "Ajouter capuchon de montant",

    questions: {
      delete: "Voulez-vous vraiment supprimer ce capuchon de montant ?",
    },

    errors: {
      alreadyPresent: "Capuchon de montant déjà présent",
      notFound: "Capuchon de montant non trouvé",
    },
  },

  railCaps: {
    createNew: "Créer un nouveau capuchon de rail",
    delete: "Supprimer le capuchon de rail",
    singular: "Capuchon de rail",
    plural: "Capuchons de rail",
    search: "Rechercher des capuchons de rail",
    edit: "Modifier le capuchon de rail",
    add: "Ajouter capuchon de rail",

    questions: {
      delete: "Voulez-vous vraiment supprimer ce capuchon de rail ?",
    },

    errors: {
      alreadyPresent: "Capuchon de rail déjà présent",
      notFound: "Capuchon de rail non trouvé",
    },
  },

  railWallFixings: {
    createNew: "Créer une nouvelle fixation murale de rail",
    delete: "Supprimer la fixation murale de rail",
    singular: "Fixation murale de rail",
    plural: "Fixations murales de rail",
    search: "Rechercher des fixations murales de rail",
    edit: "Modifier la fixation murale de rail",
    add: "Ajouter fixation murale de rail",

    questions: {
      delete: "Voulez-vous vraiment supprimer cette fixation murale de rail ?",
    },

    errors: {
      alreadyPresent: "Fixation murale de rail déjà présente",
      notFound: "Fixation murale de rail non trouvée",
    },
  },

  railCorners: {
    createNew: "Créer un nouvel angle de rail",
    delete: "Supprimer l'angle de rail",
    singular: "Angle de rail",
    plural: "Angles de rail",
    search: "Rechercher des angles de rail",
    edit: "Modifier l'angle de rail",
    add: "Ajouter angle de rail",

    questions: {
      delete: "Voulez-vous vraiment supprimer cet angle de rail ?",
    },

    errors: {
      alreadyPresent: "Angle de rail déjà présent",
      notFound: "Angle de rail non trouvé",
    },
  },

  gates: {
    createNew: "Créer une nouvelle porte",
    delete: "Supprimer la porte",
    singular: "Porte",
    plural: "Portes",
    search: "Rechercher des portes",
    edit: "Modifier la porte",
    add: "Ajouter porte",

    questions: {
      delete: "Voulez-vous vraiment supprimer cette porte ?",
    },

    errors: {
      alreadyPresent: "Porte déjà présente",
      notFound: "Porte non trouvée",
    },
  },

  waterproofKits: {
    createNew: "Créer un nouveau kit d'étanchéité",
    delete: "Supprimer le kit d'étanchéité",
    singular: "Kit d'étanchéité",
    plural: "Kits d'étanchéité",
    search: "Rechercher des kits d'étanchéité",
    edit: "Modifier le kit d'étanchéité",
    add: "Ajouter kit d'étanchéité",

    questions: {
      delete: "Voulez-vous vraiment supprimer ce kit d'étanchéité ?",
    },

    errors: {
      alreadyPresent: "Kit d'étanchéité déjà présent",
      notFound: "Kit d'étanchéité non trouvé",
    },
  },

  fastenings: {
    singular: "Fixation",
  },

  fasteningChoices: {
    createNew: "Créer une nouvelle combinaison de fixations",
    delete: "Supprimer la combinaison de fixations",
    edit: "Modifier la combinaison de fixations",
    singular: "Combinaison de fixations",
    plural: "Combinaisons de fixations",
    search: "Rechercher des combinaisons de fixations",
    combination: "Combinaison",
    factorPerUpright: "Facteur par montant",

    questions: {
      delete: "Voulez-vous vraiment supprimer cette combinaison de fixations ?",
    },

    errors: {
      alreadyPresent: "Combinaison de fixations déjà présente",
      duplicateFastening: "Fixation sélectionnée en double",
      notFound: "Combinaison de fixations non trouvée",
    },
  },

  membraneProtections: {
    createNew: "Créer une nouvelle membrane protectrice",
    delete: "Supprimer la membrane protectrice",
    singular: "Membrane protectrice",
    plural: "Membranes protectrices",
    search: "Rechercher des membranes protectrices",
    edit: "Modifier la membrane protectrice",
    add: "Ajouter membrane protectrice",

    questions: {
      delete: "Voulez-vous vraiment supprimer cette membrane protectrice ?",
    },

    errors: {
      alreadyPresent: "Membrane protectrice déjà présente",
      notFound: "Membrane protectrice non trouvée",
    },
  },

  workMethods: {
    singular: "Méthode de travail",
    plural: "Méthodes de travail",
    deleteLabel: "méthode de travail",
    new: "Nouvelle méthode de travail",
    edit: "Modifier la méthode de travail",
    delete: "Supprimer la méthode de travail",
    search: "Rechercher des méthodes de travail",
  },
  supports: {
    singular: "Support",
    plural: "Supports",
    deleteLabel: "support",
    new: "Nouveau support",
    edit: "Modifier le support",
    delete: "Supprimer le support",
    search: "Rechercher des supports",
  },
  labelLanguages: {
    singular: "Langue d'étiquette",
    plural: "Langues d'étiquette",
    deleteLabel: "langue d'étiquette",
    new: "Nouvelle langue d'étiquette",
    edit: "Modifier la langue d'étiquette",
    delete: "Supprimer la langue d'étiquette",
    search: "Rechercher des langues d'étiquette",
  },
  towers: {
    singular: "Tour",
    plural: "Tours",
    deleteLabel: "tour",
    new: "Nouvelle tour",
    edit: "Modifier la tour",
    delete: "Supprimer la tour",
    search: "Rechercher des tours",
  },
  trolleys: {
    singular: "Chariot",
    plural: "Chariots",
    deleteLabel: "chariot",
    new: "Nouveau chariot",
    edit: "Modifier le chariot",
    delete: "Supprimer le chariot",
    search: "Rechercher des chariots",
  },
  railCurves: {
    singular: "Courbe de rail",
    plural: "Courbes de rail",
    deleteLabel: "courbe de rail",
    new: "Nouvelle courbe de rail",
    edit: "Modifier la courbe de rail",
    delete: "Supprimer la courbe de rail",
    search: "Rechercher des courbes de rail",
  },
  railJunctions: {
    singular: "Jonction de rail",
    plural: "Jonctions de rail",
    deleteLabel: "jonction de rail",
    new: "Nouvelle jonction de rail",
    edit: "Modifier la jonction de rail",
    delete: "Supprimer la jonction de rail",
    search: "Rechercher des jonctions de rail",
  },
  railTerminals: {
    singular: "Terminal de rail",
    plural: "Terminaux de rail",
    deleteLabel: "terminal de rail",
    new: "Nouveau terminal de rail",
    edit: "Modifier le terminal de rail",
    delete: "Supprimer le terminal de rail",
    search: "Rechercher des terminaux de rail",
  },
  screws: {
    singular: "Vis",
    plural: "Vis",
    deleteLabel: "vis",
    new: "Nouvelle vis",
    edit: "Modifier la vis",
    delete: "Supprimer la vis",
    search: "Rechercher des vis",
  },
  tools: {
    singular: "Outil",
    plural: "Outils",
    deleteLabel: "outil",
    new: "Nouvel outil",
    edit: "Modifier l'outil",
    delete: "Supprimer l'outil",
    search: "Rechercher des outils",
  },
  fasteningOptions: {
    singular: "Option de fixation",
    plural: "Options de fixation",
    deleteLabel: "option de fixation",
    new: "Nouvelle option de fixation",
    edit: "Modifier l'option de fixation",
    delete: "Supprimer l'option de fixation",
    search: "Rechercher des options de fixation",
  },
  fasteningOptionItems: {
    singular: "Élément d'option de fixation",
    plural: "Éléments d'option de fixation",
    deleteLabel: "élément d'option de fixation",
    new: "Nouvel élément d'option de fixation",
    edit: "Modifier l'élément d'option de fixation",
    delete: "Supprimer l'élément d'option de fixation",
    search: "Rechercher des éléments d'option de fixation",
  },
  itemExtras: {
    singular: "Article extra",
    plural: "Extras",
    deleteLabel: "article extra",
    new: "Nouvel article extra",
    edit: "Modifier l'article extra",
    delete: "Supprimer l'article extra",
    search: "Rechercher des extras",
  },
  supportItems: {
    singular: "Élément de support",
    plural: "Éléments de support",
    deleteLabel: "élément de support",
    new: "Nouvel élément de support",
    edit: "Modifier l'élément de support",
    delete: "Supprimer l'élément de support",
    search: "Rechercher des éléments de support",
  },
  systemSupportOptions: {
    singular: "Option de support du système",
    plural: "Options de support du système",
    deleteLabel: "option de support du système",
    new: "Nouvelle option de support du système",
    edit: "Modifier l'option de support du système",
    delete: "Supprimer l'option de support du système",
    search: "Rechercher des options de support du système",
  },

  common: {
    active: "Actif",
    accept: "Accepter",
    add: "Ajouter",
    addNewItem: "Ajouter un nouvel article",
    address: "Adresse",
    administration: "Administration",
    allow: "Autoriser",
    deny: "Refuser",
    shared: "Partagé",
    canEdit: "Peut modifier",
    alreadyPresent: "Déjà présent",
    general: "Général",
    itemDependencies: "Dépendances d'articles",
    millimeters: " mm",
    deduction: "Déduction",
    nominalAngle: "Angle nominal",
    deflection: "Déflexion",
    horizontalDeduction: "Déduction horizontale",
    internalDeduction: "Déduction intérieure",
    externalDeduction: "Déduction extérieure",
    doubleTerminal: "Terminal double",
    doubleTerminalVisible: "Terminal double visible",
    factorPerFasteningPoint: "Facteur par point de fixation",
    factorPerLabel: "Facteur par étiquette",
    fasteningOption: "Option de fixation",
    fasteningPoints: "Points de fixation",
    fasteningPointsPerSupport: "Points de fixation par support",
    floor: "Sol",
    overhead: "Suspendu",
    wall: "Mur",
    none: "Aucun",
    required: "Requis",
    horizontal: "Horizontal",
    vertical: "Vertical",
    terminalTypeClosed: "Fermé",
    terminalTypeOpen: "Ouvert",
    jointHoleTemplateVisible: "Modèle de trous de jonction visible",
    jointTemplate: "Modèle de jonction",
    junctions: "Jonctions",
    junctionsRequired: "Jonctions requises",
    mountingContext: "Contexte de montage",
    plane: "Plan",
    quantity: "Quantité",
    quantityPerItem: "Quantité par article",
    quantityPerSupport: "Quantité par support",
    supportsRequired: "Supports requis",
    hrailSupport: "Support",
    systemHeader: (title: string) => `Système : ${title}`,
    terminalType: "Type de terminal",
    tower: "Tour",
    workMethod: "Méthode de travail",
    fasteningOptionHeader: (title: string) => `Option de fixation : ${title}`,
    deleteEntityQuestion: (entity: string, label: string) => `Supprimer ${entity} "${label}" ?`,
    archived: "Archivé",
    atLeastOneItemNeeded: "Au moins un article est nécessaire.",
    author: "Auteur",
    automaticSync: "Synchronisation automatique",
    baseOrientation: "Orientation de base",
    cornerClassification: "Classification de l'angle",
    back: "Retour",
    baseHeight: "Hauteur de base",
    breadcrumb: "Fil d'Ariane",
    cancel: "Annuler",
    close: "Fermer",
    city: "Ville",
    code: "Code",
    company: "Entreprise",
    confirmed: "Confirmé",
    contactPerson: "Personne de contact",
    contactPersonWarning:
      "La saisie de ces données est volontaire et se fait sous l'entière responsabilité de l'utilisateur. Il n'est pas recommandé d'introduire des données qui identifient ou rendent identifiables des personnes.",
    cookiePolicy: "Politique relative aux cookies",
    coordinates: "Coordonnées",
    copy: "Copie",
    corners: "Angles",
    country: "Pays",
    corrugationSpan: "Largeur de l'ondulation",
    curb: "Bordure",
    curbHeight: "Hauteur de la bordure",
    curbDepth: "Profondeur de la bordure",
    curbHeightBelowMinimum: (value: number) => `La hauteur minimale de la bordure pour cette sélection est de ${value} mm`,
    curbDepthBelowBaseHeight: (value: number) =>
      `La profondeur de la bordure doit être d'au moins ${value} mm pour accueillir la base sélectionnée`,
    create: "Créer",
    curved: "Courbé",
    created: "Créé",
    createNew: "Créer nouveau",
    currentRoofDoesNotAllowAnchorPoints:
      "La configuration actuelle du toit ne permet pas l'utilisation de points d'ancrage individuels.",
    dataHasBeenSavedSuccessfully: "Les données ont été enregistrées avec succès.",
    date: "Date",
    decrease: (value: number) => `Diminuer ${value}`,
    download: "Télécharger",
    delete: "Supprimer",
    description: "Description",
    descriptionLong: "Description (longue)",
    descriptionShort: "Description (courte)",
    details: "Détails",
    diameter: "Diamètre",
    distance: "Distance",
    dragAndDropOrUploadAnImage: "Glissez-déposez ou cliquez pour télécharger une image",
    dropIt: "Déposez-le !",
    duplicate: "Dupliquer",
    edit: "Modifier",
    writePermissions: "Permissions d'écriture",
    permissionToEdit: "Permission de modifier",
    editor: "Éditeur",
    email: "E-mail",
    error: "Erreur",
    errorLoadingData: "Erreur de chargement des données",
    excel: "Excel",
    failed: "Échoué",
    fieldCannotBeEmpty: "Le champ ne peut pas être vide.",
    fieldContainsInvalidValueInsertBiggerOne: "Le champ contient une valeur invalide, insérez une valeur plus grande.",
    fieldContainsInvalidValueInsertSmallerOne: "Le champ contient une valeur invalide, insérez une valeur plus petite.",
    fieldValueInvalidFormat: "La valeur a un format invalide.",
    fieldInvalidValue: "Le champ contient une valeur invalide.",
    fixed: "Fixe",
    forbidden: "Non autorisé",
    generalData: "Données générales",
    genericError: "Une erreur est survenue, veuillez réessayer.",
    guardrailComposition: "Composition de garde-corps",
    heightToReach: "Hauteur à atteindre",
    hidden: "Caché",
    home: "Accueil",
    increase: (value: number) => `Augmenter ${value}`,
    installed: "Installé",
    intermediateSupport: "Support intermédiaire",
    isVisible: "Est visible",
    isBallastRequired: "Le lest est-il requis",
    isFasteningVisible: "La fixation est-elle visible",
    isGateVisible: "La porte est-elle visible",
    isHighWindVisible: "Haute résistance au vent visible",
    isIntermediateBarRequired: "Barre intermédiaire requise",
    isSubstructureRequired: "La sous-structure est-elle requise",
    isSubstructureDetailsRequired: "Détails de la sous-structure requis",
    isPerimeterSplitRequired: "Répartition du périmètre requise",
    isCornerOrientationRequired: "Orientation des angles requise",
    isReclinableUpright: "Est rabattable",
    isCurbVisible: "Bordure visible",
    isCurbDepthVisible: "Profondeur de la bordure visible",
    isReinforced: "Est renforcé",
    isToeBoardRequired: "Plinthe requise",
    isVertical: "Est-ce vertical",
    isVerticalBaseTypeRequired: "Un type de base vertical est-il requis",
    isWaterproofKitVisible: "Le kit d'étanchéité est-il visible",
    isWedgeVisible: "La cale est-elle visible",
    visibility: "Visibilité",
    rothoblaasUsers: "Utilisateurs Rothoblaas",
    externalUsers: "Utilisateurs externes",
    everyOne: "Tout le monde",
    ladderExitDifference: "Difference sortie échelle",
    translations: "Traductions",
    appLanguage: "Langue de l'application",
    languages: {
      singular: "Langue",
      plural: "Langues",
      arabic: "Arabe",
      czech: "Tchèque",
      danish: "Danois",
      german: "Allemand",
      greek: "Grec",
      english: "Anglais",
      spanish: "Espagnol",
      estonian: "Estonien",
      finnish: "Finnois",
      french: "Français",
      croatian: "Croate",
      hungarian: "Hongrois",
      icelandic: "Islandais",
      italian: "Italien",
      japanese: "Japonais",
      lithuanian: "Lituanien",
      latvian: "Letton",
      dutch: "Néerlandais",
      norwegian: "Norvégien",
      polish: "Polonais",
      portugese: "Portugais",
      russian: "Russe",
      slovak: "Slovaque",
      slovenian: "Slovène",
      swedish: "Suédois",
      turkish: "Turc",
      chinese: "Chinois",
      korean: "Coréen",
    },
    firstName: "Prénom",
    lastAccess: "Dernier accès",
    lastModified: "Dernière modification",
    lastName: "Nom de famille",
    lastSync: "Dernière synchronisation",
    left: "Gauche",
    loading: "Chargement...",
    location: "Emplacement",
    login: "Se connecter",
    logout: "Se déconnecter",
    lowerSupport: "Support inférieure",
    lowerHoleDiameter: "Diamètre du trou inférieur",
    minimumConfigurableQuantity: "Quantité minimale configurable",
    minimumOrderQuantity: "Quantité minimale de commande",
    minOrderQuantity: "Qté min commande",
    myArea: "Mon espace",
    myProfile: "Mon profil",
    name: "Nom",
    next: "Suivant",
    never: "jamais",
    newConfigurationName: "Nouveau nom configuration",
    nextNRows: (n: number) => `Lignes suivantes ${n}`,
    no: "Non",
    noItemsFound: "Aucun élément trouvé.",
    notFound: "Non trouvé",
    nrBallastIntermediate: "Nbre de lests intermédiaires",
    nrBallastTerminal: "Nbre de lests terminaux",
    nrIntermediatesAndSpan: "Nbre d'intermédiaires et portée",
    nrRivets: "Nbre de rivets",
    nrOfFixingItemsRequired: "Nombre d'éléments de fixation requis (par matériau de mur)",
    offer: "Offre",
    ok: "Ok",
    onlyImagesAreAllowed: "Seules les images sont autorisées.",
    open: "Ouvrir",
    optional: "optionnel",
    order: "Ordre",
    overwrite: "Écraser",
    previousNRows: (n: number) => `Lignes précédentes ${n}`,
    print: "Imprimer",
    privacyPolicy: "Politique de confidentialité",
    qty: "Qté.",
    reject: "Refuser",
    removable: "Retirable",
    rename: "Renommer",
    reclining: "Rabattable",
    remove: "Retirer",
    removeImage: "Retirer l'image",
    reinforcedRailRequired: "Rail renforcé requis",
    reset: "Réinitialiser",
    resetToDefault: "Réinitialiser par défaut",
    resourceNotFound: "La ressource que vous recherchez est introuvable.",
    right: "Droite",
    save: "Enregistrer",
    saved: "Enregistré",
    draft: "Brouillon",
    search: "Rechercher",
    select: "Sélectionner",
    selectProject: "Sélectionner un projet",
    selectProjectFirst: "Sélectionner un projet d'abord",
    selectProjectInwhichCreateCopy: "Sélectionnez le projet dans lequel créer la copie",
    sessionExpired: "Session expiré",
    sessionExpiredText: "Veuillez vous reconnecter pour continuer à utiliser l'application.",
    settings: "Paramètres",
    status: "Statut",
    straight: "Droit",
    sync: "Synchroniser",
    targa: "Targa",
    testEnvironment: "Environnement de test",
    toBeInstalled: "À installer",
    toInspect: "À inspecter",
    uploadedAt: "Téléchargé",
    uploadedBy: "Téléchargé par",
    upperSupport: "Support supérieure",
    upperHoleDiameter: "Diamètre du trou supérieur",
    value: "Valeur",
    visible: "Visible",
    yes: "Oui",
    youAreNotAllowed: "Vous n'êtes pas autorisé à accéder à cette ressource.",
    youCannotMixUpSubstructureHeightSizeAndThickness:
      "Vous ne pouvez pas mélanger la hauteur de la sous-structure, la taille et l'épaisseur de la plaque métallique.",
    youCannotMixUpSubstructureMaxSpanAndMaxInsulationThickness:
      "Vous ne pouvez pas mélanger la portée maximale de la sous-structure et l'épaisseur maximale de l'isolation.",
    canBeCustom: "Peut être personnalisé",
    canBeMultiple: "Peut être multiple",
    categories: "Catégories",
    codeItem: "Code de l'article",
    codeExtraItem: "Code de l'article supplémentaire",
    components: "Composants",
    curves: "Courbes",
    draw: "Dessiner",
    excludedItems: "Éléments exclus",
    extensions: "Extensions",
    extras: "Extras",
    flatRoofCompatible: "Compatible toit plat",
    hasHips: "A des arêtes",
    height: "Hauteur",
    image: "Image",
    hipLength: "Longueur d'arête",
    hipsSpan: "Portée d'arêtes",
    hipsSpanRequired: "Portée d'arêtes requise",
    insulationThickness: "Épaisseur d'isolation",
    insulationThicknessRequired: "Épaisseur d'isolation requise",
    intermediates: "Intermédiaires",
    isFlat: "Est plat",
    isLifeLine: "Est une ligne de vie",
    length: "Longueur",
    loop: "Boucle",
    mappings: "Correspondances",
    max: "Maximum",
    maxInsulationThickness: "Épaisseur maximale d'isolation",
    maxPitch: "Pente maximale",
    maxSpan: "Portée maximale",
    maxThickness: "Épaisseur maximale",
    maxUsers: "Utilisateurs maximum",
    min: "Minimum",
    minMetalPlateThickness: "Épaisseur minimale de plaque métallique",
    minSubstructureHeight: "Hauteur minimale de sous-structure",
    minSubstructureSize: "Taille minimale de sous-structure",
    minThickness: "Épaisseur minimale",
    minCurbHeight: "Hauteur minimale du trottoir",
    minHeight: "Hauteur minimale",
    minSpan: "Portée minimale",
    minValue: "Valeur minimale",
    minWidth: "Largeur minimale",
    notLoop: "Pas de boucle",
    notRightAngle: "Pas d'angle droit",
    nrOfShuttlesForLifeLines: "Nombre de navettes pour lignes de vie",
    nrOfShuttlesRequestted: "Nombre de navettes demandées",
    perimeter: "Périmètre",
    closedPerimeter: "Périmètre fermé",
    perimeterLength: "Longueur totale du périmètre",
    perimeterLengthParallel: "Longueur parallèle à l'ondulation",
    perimeterLengthPerpendicular: "Longueur perpendiculaire à l'ondulation",
    cornerCountTotal: "Nombre total d'angles",
    cornerCountInternal: "Nombre d'angles internes",
    cornerCountExternal: "Nombre d'angles externes",
    parallel: "Parallèle",
    perpendicular: "Perpendiculaire",
    internal: "Interne",
    external: "Externe",
    pitch: "Pente",
    pleaseSpecifyAHeight: "Veuillez spécifier une hauteur",
    pleaseSpecifyAWidth: "Veuillez spécifier une largeur",
    pleaseSpecifyHeightAndWidth: (height: number, width: number, unit: string) =>
      `Veuillez spécifier (hauteur)x(largeur): ${height}x${width} ${unit}`,
    rightAngle: "Angle droit",
    roof: "Toit",
    roofInfo: "Information du toit",
    roofs: "Toits",
    roofWeight: "Poids du toit",
    roofWeightRequired: "Poids du toit requis",
    seamHeight: "Hauteur de joint",
    seamHeightRequired: "Hauteur de joint requise",
    seamsSpan: "Portée des joints",
    seamsSpanRequired: "Portée des joints requise",
    sheetMaterialRequired: "Matériau de tôle requis",
    span: "Portée",
    stepHeightRequired: "Hauteur de marche requise",
    substructureHeight: "Hauteur de sous-structure",
    substructures: "Sous-structures",
    substructureSize: "Taille de sous-structure",
    supports: "Supports",
    supportHeight: "Hauteur de support",
    supportMaterialRequired: "Matériau de support requis",
    supportSelection: "Sélection de support",
    type: "Type",
    types: "Types",
    caps: "Capuchons",
    useOnlyAnchorPoints: "Utiliser uniquement les points d'ancrage",
    wallFixings: "Fixations murales",
    waveSpan: "Portée d'onde",
    waveSpanRequired: "Portée d'onde requise",
    width: "Largeur",
    componentMaterial: "Matériau du composant",
    componentMaterials: "Matériaux des composants",
    lifeLineAnchors: "Points d'ancrage de ligne de vie",
    absorberAllowsMaxNUsers: (n: number) => `L'absorbeur permet maximum ${n} utilisateurs`,
    metalPlateThickness: "Épaisseur de plaque métallique",
    supportIntermediateElement: "Élément intermédiaire de support",
    supportIntermediateElements: "Éléments intermédiaires de support",
    supportTerminalCurve: "Courbe terminale de support",
    extraItem: "Article supplémentaire",
    forLoop: "Pour boucle",
    forNotLoop: "Pour non-boucle",
    invitationHasBeenSentSuccessfully: "Invitation envoyée avec succès",
    invite: "Inviter",
    invitePage: {
      fallbackAuthorName: "un membre de l'equipe",
      invitedBy: "Invite par",
      invitationSentTo: "Invitation envoyee a",
      description: "Description",
      notAvailable: "Non disponible",
      acceptAction: "Accepter l'invitation",
      rejectAction: "Refuser l'invitation",
      notFoundTitle: "Invitation introuvable",
    },
    isAnchorPoint: "Est un point d'ancrage",
    stepHeight: "Hauteur de marche",
    addPoints: "Ajouter des points",
    angle: "Angle",
    angles: "Angles",
    bottomClamp: "Pince inférieure",
    bottomItems: "Éléments inférieurs",
    clamped: "Pincé",
    clampThickness: "Épaisseur de pince",
    curve: "Courbe",
    default: "Par défaut",
    defaultPitch: "Pente par défaut",
    degrees: "Degrés",
    editCurve: "Modifier la courbe",
    editPatrolComponent: "Modifier le composant Patrol",
    editTerminal: "Modifier le terminal",
    erease: "Effacer",
    factor: "Facteur",
    finish: "Terminer",
    forTerminalsAndCurves: "Pour terminaux et courbes",
    forIntermediates: "Pour intermédiaires",
    globalSettings: "Paramètres globaux",
    help: "Aide",
    hide: "Masquer",
    hipsSpans: "Portées d'arêtes",
    includeSelectedComponent: "Inclure le composant sélectionné",
    includeTarga: "Inclure Targa",
    intermediate: "Intermédiaire",
    intersectionPoint: "Point d'intersection",
    isClampable: "Est pinçable",
    isSubstructureIndependent: "Est indépendant de la sous-structure",
    lifeLine: "Ligne de vie",
    lifeLinePlusAnchorPoint: "Ligne de vie + point d'ancrage",
    lifeLinesAndAnchorPointsHaveBeenFound_message:
      "Des lignes de vie et points d'ancrage ont été trouvés. Pour modifier les paramètres du toit, vous devez supprimer ces données. Cliquez sur 'Supprimer' pour les supprimer et libérer le formulaire",
    lifeLineSegment: "Segment de ligne de vie",
    maxAngle: "Angle maximal",
    maxCornersPerLifeline: "Coins maximaux par ligne de vie",
    maxHeight: "Hauteur maximale",
    maxSeamsSpan: "Portée maximale des joints",
    maxSpanBetweenCurveAndIntermediate: "Portée maximale entre courbe et intermédiaire",
    maxSpanBetweenIntermediate: "Portée maximale entre intermédiaires",
    minAngle: "Angle minimal",
    minSpanBetweenSupports: "Portée minimale entre supports",
    minPitch: "Pente minimale",
    noAdditionalPost: "Pas de poteau supplémentaire",
    normativeDetails: "Détails normatifs",
    onlyAnchorPoint: "Point d'ancrage uniquement",
    onlyFor: "Uniquement pour",
    onlyLifeLine: "Ligne de vie uniquement",
    optionals: "Optionnels",
    pitchMinMaxDefault: "Pente (min/max/défaut)",
    pleaseSpecifyAMaxHeight: "Veuillez spécifier une hauteur maximale",
    pleaseSpecifyAMinHeight: "Veuillez spécifier une hauteur minimale",
    pleaseSpecifyAValueBetween: (min: number, max: number | null, unit: string | null) =>
      (max
        ? `Veuillez spécifier une valeur entre ${min} et ${max}`
        : `Veuillez spécifier une valeur supérieure à ${min}`) + (unit ? ` ${unit}` : "").trim(),
    searchIntermediatedCurves: "Rechercher intermédiaires/courbes",
    selectedComponent: "Composant sélectionné",
    show: "Afficher",
    spans: "Portées",
    splitLifeLineHere: "Diviser la ligne de vie ici",
    stepHeightRange: "Plage de hauteur de marche",
    support: "Support",
    supportCurve: "Courbe de support",
    supportTerminal: "Terminal de support",
    supportTerminalAndCurve: "Terminal et courbe de support",
    terminal: "Terminal",
    terminal_plus_intermediate: "Terminal+intermédiaire",
    terminalAndCurve: "Terminal et courbe",
    terminalCurves: "Terminaux/courbes",
    terminalCurveAndIntermediate: "Terminal, courbe et intermédiaire",
    termsAndConditions: "Termes et Conditions",
    theMaximumAllowedValueIs: (value: number) => `La valeur maximale autorisée est ${value}°`,
    theMinimumAllowedValueIs: (value: number) => `La valeur minimale autorisée est ${value}°`,
    theMaximulAllowedLifeLineLengthExceeds: (
      meters: number,
      curves: number,
      maxLength: number,
      allowedLength: number,
    ) =>
      `La ligne de sécurité du segment sélectionné a une longueur de ${meters} mètres. En raison des ${curves} courbes, la longueur maximale autorisée de ${maxLength} mètres est réduite à ${allowedLength}. Veuillez diviser la ligne.`,
    theMinAngleIfIntermediateAndTerminalforTheSystemIs_degrees: (degrees: number) =>
      `Le système sélectionné ne permet pas des courbes avec un angle inférieur à ${degrees}°.`,
    theMinAngleOfCurveForTheSystemIs_degrees: (degrees: number) =>
      `Le système sélectionné avec une intersection (terminale et intermédiaire) ne permet qu'une ligne presque droite (minimum ${degrees}°).`,
    theSystemRequiresAMinSpanOfXMeters: (minSpan: number) =>
      `Le système requiert une distance minimale de ${minSpan} mètres.`,
    topClamp: "Pince supérieure",
    topExtraItem: "Article supplémentaire supérieur",
    topItem: "Article supérieur",
    unlock: "Déverrouiller",
    unshare: "Ne plus partager",
    update: "Mettre à jour",
    versions: "Versions",
    warningThisEditCouldAffectOtherSystemsAsWell:
      "Attention : cette modification pourrait également affecter d'autres systèmes",
    from: "De",
    meters: "À",
    terminal_plus_terminal: "Terminal + terminal",
    to: "Mètres",
    defaultSupports: "Supports par défaut",
    supportRequired: "Support requis",
    supportsHeight: "Hauteur des supports",
  },
  elements: {
    createNew: "Créer un nouvel élément",
    delete: "Supprimer l'élément",
    edit: "Modifier l'élément",
    singular: "Élément",
    plural: "Éléments",
    search: "Rechercher des éléments",
    questions: {
      delete: "Voulez-vous vraiment supprimer cet élément ?",
    },
    errors: {
      alreadyPresent: "Élément déjà présent",
      notFound: "Élément non trouvé",
      inUseByConfiguration: "L'élément est encore utilisé par une configuration",
    },
  },
  terminals: {
    createNew: "Créer un nouveau terminal",
    delete: "Supprimer le terminal",
    edit: "Modifier le terminal",
    singular: "Terminal",
    plural: "Terminaux",
    search: "Rechercher des terminaux",
    questions: {
      delete: "Voulez-vous vraiment supprimer ce terminal ?",
    },
    errors: {
      alreadyPresent: "Terminal déjà présent",
      notFound: "Terminal non trouvé",
      inUseByConfiguration: "Le terminal est encore utilisé par une configuration",
    },
  },
  roofTypes: {
    createNew: "Créer un nouveau type de toit",
    delete: "Supprimer le type de toit",
    singular: "Type de toit",
    plural: "Types de toit",
    search: "Rechercher des types de toit",
    questions: {
      delete: "Voulez-vous vraiment supprimer ce type de toit ?",
    },
    errors: {
      pleaseSelectRoofType: "Veuillez sélectionner un type de toit",
    },
  },
  roofCategories: {
    createNew: "Créer une nouvelle catégorie de toit",
    delete: "Supprimer la catégorie de toit",
    singular: "Catégorie de toit",
    plural: "Catégories de toit",
    search: "Rechercher des catégories de toit",
    questions: {
      delete: "Voulez-vous vraiment supprimer cette catégorie de toit ?",
    },
    errors: {
      pleaseSelectRoofCategory: "Veuillez sélectionner une catégorie de toit",
      inUseByRoofType: "La catégorie est encore utilisée par un type de toit",
    },
  },
  roofMaterials: {
    createNew: "Créer un nouveau matériau de toit",
    delete: "Supprimer le matériau de toit",
    singular: "Matériau de toit",
    plural: "Matériaux de toit",
    search: "Rechercher des matériaux de toit",
    questions: {
      delete: "Voulez-vous vraiment supprimer ce matériau de toit ?",
    },
  },
  materials: {
    createNew: "Créer un nouveau matériau",
    delete: "Supprimer le matériau",
    singular: "Matériau",
    plural: "Matériaux",
    search: "Rechercher des matériaux",
    questions: {
      delete: "Voulez-vous vraiment supprimer ce matériau ?",
    },
  },
  roofSubstructures: {
    createNew: "Créer une nouvelle sous-structure de toit",
    delete: "Supprimer la sous-structure de toit",
    singular: "Sous-structure de toit",
    single: "Sous-structure de toit",
    plural: "Sous-structures de toit",
    search: "Rechercher des sous-structures de toit",
    questions: {
      delete: "Voulez-vous vraiment supprimer cette sous-structure de toit ?",
    },
  },
  sheetMaterials: {
    createNew: "Créer un nouveau matériau de tôle",
    delete: "Supprimer le matériau de tôle",
    edit: "Modifier le matériau de tôle",
    singular: "Matériau de tôle",
    plural: "Matériaux de tôle",
    search: "Rechercher des matériaux de tôle",
    questions: {
      delete: "Voulez-vous vraiment supprimer ce matériau de tôle ?",
    },
  },
  patrolSystems: {
    createNew: "Créer un nouveau système Patrol",
    delete: "Supprimer le système Patrol",
    singular: "Système Patrol",
    plural: "Systèmes Patrol",
    search: "Rechercher des systèmes Patrol",
    questions: {
      delete: "Voulez-vous vraiment supprimer ce système Patrol ?",
    },
  },
  patrolSystemMappings: {
    createNew: "Créer une nouvelle correspondance système",
    delete: "Supprimer la correspondance système",
    edit: "Modifier la correspondance système",
    singular: "Correspondance système",
    plural: "Correspondances système",
    search: "Rechercher des correspondances système",
    questions: {
      delete: "Voulez-vous vraiment supprimer cette correspondance système ?",
    },
  },
  systemNormatives: {
    createNew: "Créer une nouvelle normative système",
    delete: "Supprimer la normative système",
    edit: "Modifier la normative système",
    singular: "Normative système",
    plural: "Normatives système",
    search: "Rechercher des normatives système",
    questions: {
      delete: "Voulez-vous vraiment supprimer cette normative système ?",
    },

    errors: {
      normativeAlreadyPresent: "La norme sélectionnée est déjà associée au système.",
    },
  },
  uprightSpanMappings: {
    createNew: "Créer une nouvelle correspondance de portée de montant",
    delete: "Supprimer la correspondance de portée de montant",
    edit: "Modifier la correspondance de portée de montant",
    singular: "Correspondance de portée de montant",
    plural: "Correspondances de portée de montant",
    search: "Rechercher des correspondances de portée de montant",
    questions: {
      delete: "Voulez-vous vraiment supprimer cette correspondance de portée de montant ?",
    },
    errors: {
      alreadyPresent: "Correspondance de portée de montant déjà présente",
      updateNotAllowed: "Vous n'êtes pas autorisé à mettre à jour cette correspondance de portée de montant.",
    },
  },
  uprightMappings: {
    createNew: "Créer une nouvelle correspondance de montant",
    delete: "Supprimer la correspondance de montant",
    edit: "Modifier la correspondance de montant",
    singular: "Correspondance de montant",
    plural: "Correspondances de montant",
    search: "Rechercher des correspondances de montant",
    questions: {
      delete: "Voulez-vous vraiment supprimer cette correspondance de montant ?",
    },
    errors: {
      alreadyPresent: "Correspondance de montant déjà présente",
    },
  },
  patrolAnchorMappings: {
    createNew: "Créer une nouvelle correspondance d'ancrage",
    delete: "Supprimer la correspondance d'ancrage",
    edit: "Modifier la correspondance d'ancrage",
    singular: "Correspondance d'ancrage",
    plural: "Correspondances d'ancrage",
    search: "Rechercher des correspondances d'ancrage",
    questions: {
      delete: "Voulez-vous vraiment supprimer cette correspondance d'ancrage ?",
    },
  },
  membranes: {
    createNew: "Créer une nouvelle membrane",
    delete: "Supprimer la membrane",
    singular: "Membrane",
    plural: "Membranes",
    search: "Rechercher des membranes",
    questions: {
      delete: "Voulez-vous vraiment supprimer cette membrane ?",
    },
    single: "Membrane",
  },
  patrolSupports: {
    createNew: "Créer un nouveau support Patrol",
    delete: "Supprimer le support Patrol",
    edit: "Modifier le support Patrol",
    singular: "Support Patrol",
    plural: "Supports Patrol",
    search: "Rechercher des supports Patrol",
    questions: {
      delete: "Voulez-vous vraiment supprimer ce support Patrol ?",
    },
  },
  itemNormativeExclusions: {
    add: "Ajouter une exclusion normative d'article",
    createNew: "Créer une nouvelle exclusion normative d'article",
    delete: "Supprimer l'exclusion normative d'article",
    edit: "Modifier l'exclusion normative d'article",
    singular: "Exclusion normative d'article",
    plural: "Exclusions normatives d'articles",
    search: "Rechercher des exclusions normatives d'articles",
    questions: {
      remove: "Voulez-vous vraiment supprimer cette exclusion normative d'article ?",
    },
    errors: {
      notFound: "Exclusion normative d'article non trouvée.",
    },
  },
  supportExtensions: {
    createNew: "Créer une nouvelle extension de support",
    delete: "Supprimer l'extension de support",
    edit: "Modifier l'extension de support",
    singular: "Extension de support",
    plural: "Extensions de support",
    search: "Rechercher des extensions de support",
    questions: {
      delete: "Voulez-vous vraiment supprimer cette extension de support ?",
    },
  },
  supportExtras: {
    createNew: "Créer un nouveau extra support",
    delete: "Supprimer l'extra support",
    edit: "Modifier l'extra support",
    singular: "Extra support",
    plural: "Extras support",
    search: "Rechercher des extras support",
    questions: {
      delete: "Voulez-vous vraiment supprimer cet extra support ?",
    },
  },
  supportOptionals: {
    createNew: "Créer un nouveau support optionnel",
    delete: "Supprimer le support optionnel",
    edit: "Modifier le support optionnel",
    singular: "Support optionnel",
    plural: "Supports optionnels",
    search: "Rechercher des supports optionnels",
    questions: {
      delete: "Voulez-vous vraiment supprimer ce support optionnel ?",
    },
  },
  clampings: {
    createNew: "Créer un nouveau serrage",
    edit: "Modifier le serrage",
    delete: "Supprimer le serrage",
    singular: "Serrage",
    plural: "Serrages",
    search: "Rechercher des serrages",
    questions: {
      delete: "Voulez-vous vraiment supprimer ce serrage ?",
    },
    errors: {
      notFound: "Serrage non trouvé.",
      inUseByConfiguration: "Le serrage est encore utilisé par une configuration.",
    },
  },
  patrolCurveIntermediates: {
    singular: "Courbe/Intermédiaire",
    plural: "Courbes/Intermédiaires",
    createNew: "Créer une nouvelle courbe/intermédiaire",
    delete: "Supprimer la courbe/intermédiaire",
    edit: "Modifier la courbe/intermédiaire",
    search: "Rechercher des courbes/intermédiaires",
    questions: {
      delete: "Voulez-vous vraiment supprimer cette courbe/intermédiaire ?",
    },
  },
  normativeVersions: {
    singular: "Version normative",
    plural: "Versions normatives",
    add: "Ajouter une version normative",
    createNew: "Créer une nouvelle version normative",
    errors: {
      atLeastOneSystemRequired: "Au moins un système est requis.",
    },
  },
  anchorPoints: {
    addNew: "Ajouter de nouveaux points d'ancrage",
    singular: "Point d'ancrage",
    plural: "Points d'ancrage",
    delete: "Supprimer le point d'ancrage",
    hide: "Masquer les points d'ancrage",
    show: "Afficher les points d'ancrage",
    questions: {
      delete: "Voulez-vous vraiment supprimer le point d'ancrage sélectionné ?",
    },
  },
  accessPoints: {
    addNew: "Ajouter de nouveaux points d'accès",
    singular: "Point d'accès",
    delete: "Supprimer le point d'accès",
    questions: {
      delete: "Voulez-vous vraiment supprimer le point d'accès sélectionné ?",
    },
  },
  lifeLines: {
    draw: "Dessiner une ligne de vie",
    singular: "Ligne de vie",
    plural: "Lignes de vie",
    delete: "Supprimer la ligne de vie",
    hide: "Masquer les lignes de vie",
    show: "Afficher les lignes de vie",
    questions: {
      deleteEdge: "Voulez-vous vraiment supprimer le segment sélectionné ?",
      deleteNode: "Voulez-vous vraiment supprimer le point d'intersection sélectionné ?",
    },
    errors: {
      creatingCrossIntersectionsNotAllowed:
        "La création d'une intersection en croix à quatre points n'est pas autorisée.",
      loopsNotAllowed: "Le système sélectionné n'autorise pas les boucles.",
      intersectionsNotAllowed: "Le système sélectionné n'autorise pas les intersections à 3 voies.",
      systemDoesNotAllowMoreThanXCorners: (maxCorners: number) =>
        `Le système sélectionné ne permet pas plus de ${maxCorners} coins`,
    },
  },
};

export default fr;
